import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';
import { AppConfig } from '../AppConfig';
import { UiHelper } from '../common/helpers/UiHelper';
import { urlBuilderFormDefinitionFields } from '../data/data';
import { Helper } from '../common/helpers/Helper';
import { DynamicFormDialog } from '../common/components/DynamicFormDialog';
import { useState } from 'react';
import queryString from 'query-string';
import { AppTheme } from '../styles/AppTheme';
import { CommonTheme } from '../styles/Styles';
const Url = require('url-parse');

const keyDict = {
  formsKey: '__id'
}
const additonalParams = ['__id', '__linkType', '__calendly', '__title', '__link']

export default function NavLinkBuilder(props) {
  const current = props.current;
  const formControlParams = props.formControlParams;
  const fields = props.formDefinition.steps[0].fields;
  const [showButtonConfig, setShowButtonConfig] = useState(false);
  // const [fieldDisabled, setFieldDisabled] = useState(true);
  // console.log('NavLinkBuilder:props', props)

  // let navLinkformDefinition = buildFormDef([]);
  let queryParamForSlixtaForms = {} //used to construct the slixta url
  let currentNavLinkKey = '' //used to identify the navigation link among the incoming params
  const formFieldPrefills = {} //used prefill our custom fields along with incoming fields in url builder dialog
  let slixtaFormUrl = 'slixta://'; //base url of slixta workflow
  const buttonFields = [];// to store incoming fields related to button
  // let buttonNumberStr = 'button1'
  let buttonNumberStr = null //to identify if its button or just navigation link (entire widget is clickable)
  if (current.groupName && current.groupName.startsWith('button1')) {
    buttonNumberStr = 'button1'
  } else if (current.groupName && current.groupName.startsWith('button2')) {
    buttonNumberStr = 'button2'
  }

  const buildFormDef = (fields) => {
    const placementModifiedFields = []
    for (const f of fields) {
      placementModifiedFields.push({
        ...f,
        placement: 'left'
      })
    }
    const baseDef = {
      steps: [
        {
          fields: [...placementModifiedFields],
        }
      ],
      ctaButtonText: 'Save',
      formType: 'add'
    }
    return baseDef
  }

  const onChangeHandler = (options, callback) => {
    const formData = options.formData
    const linkType = formData.__linkType
    delete formData.__linkType
    queryParamForSlixtaForms = {}
    for (const key in formData) {
      if (linkType === 'normalLink') {
        //nothing to do
      } else if (linkType === 'formpopup' && ['__id', '__calendly', '__title'].includes(key)) {
        if (formData[key]) queryParamForSlixtaForms[key.replace('__', '')] = formData[key]
      } else if (linkType === 'videopopup') {
        if (key === '__link') {
          if (formData[key]) queryParamForSlixtaForms[key.replace('__', '')] = formData[key]
        }
      }
      if (additonalParams.includes(key)) delete formData[key]
    }
    if (linkType === 'formpopup') {
      const queryParams = Helper.encodeQueryString(queryParamForSlixtaForms);
      slixtaFormUrl = slixtaFormUrl + 'formpopup?' + queryParams;
      formData[currentNavLinkKey] = slixtaFormUrl
    }
    if (linkType === 'videopopup') {
      const queryParams = Helper.encodeQueryString(queryParamForSlixtaForms);
      slixtaFormUrl = slixtaFormUrl + 'videopopup?' + queryParams;
      formData[currentNavLinkKey] = slixtaFormUrl
    }
    for (const key in formData) {
      if (key === 'REMOVE_ATTRS') continue;
      const event = {
        target: {
          id: key,
          value: formData[key],
        }
      };
      props.onChange(event);
    }
    if (!formData.REMOVE_ATTRS || formData.REMOVE_ATTRS.length === 0) return callback();
    for (const key of formData.REMOVE_ATTRS) {
      const event = {
        target: {
          id: key,
          value: '',
        },
      };
      props.onChange(event);
    }
    callback()
  }

  const isOnlyNavLink = () => {
    if(buttonFields.length === 1 && buttonFields[0].key === 'navLink') return true
    return false
  }
  // creating & generate prefill dict form defenition to show in url bulder dialog
  for (let index = 0; index < fields.length; index++) {
    const field = fields[index];
    if (buttonNumberStr && (field.groupName && field.groupName.startsWith(buttonNumberStr))
      || (buttonNumberStr === 'button1' && field.key === 'navLink')) {
      buttonFields.push({
        ...field,
        hidden: false,
      });
      if (field.groupName && field.groupName.includes('-navLink') || field.key === 'navLink') {
        field.label = 'Navigation Link'
        field.placement = 'left'
        field.condition = { key: '__linkType', value: 'normalLink' }
        currentNavLinkKey = field.key
      }
      if (props.allKeysData[field.key]) {
        formFieldPrefills[field.key] = props.allKeysData[field.key] //direct assignment - since we know currently all fields are text inputs
      } else {
        field.value = '';
      }
    } else if (current.key === 'navLink') {
      if (field.key === 'navLink') {
        buttonFields.push({
          ...field,
          hidden: false,
          label: 'Navigation Link',
          placement: 'left',
          condition: { key: '__linkType', value: 'normalLink' }
        });
        currentNavLinkKey = field.key
        if (props.allKeysData[field.key]) {
          formFieldPrefills[field.key] = props.allKeysData[field.key] //direct assignment - since we know currently all fields are text inputs
        } else {
          field.value = '';
        }
      }
    }
  }

  const mergedFields = [
    ...urlBuilderFormDefinitionFields.slice(0, 1),
    ...buttonFields,
    ...urlBuilderFormDefinitionFields.slice(1)
  ];
  const navLinkformDefinition = buildFormDef(mergedFields);
  navLinkformDefinition.ctaButtonText = Helper.getString('set')
  /* ********************************* */

  //generate prefill dict
  if (props.forms) {
    UiHelper.populateOptions(navLinkformDefinition, props.forms, keyDict.formsKey);
  }
  if (props.allKeysData[currentNavLinkKey]) {
    const slixtaFlowUrl = new Url(props.allKeysData[currentNavLinkKey]);
    const parsedQuery = queryString.parse(slixtaFlowUrl.query)
    if (slixtaFlowUrl.host === 'videopopup') {
      formFieldPrefills.__linkType = 'videopopup'
      if (parsedQuery.link) formFieldPrefills.__link = parsedQuery.link
    } else if (slixtaFlowUrl.host === 'formpopup') {
      formFieldPrefills.__linkType = 'formpopup'
      if (parsedQuery.title) formFieldPrefills.__title = parsedQuery.title
      if (parsedQuery.id) formFieldPrefills.__id = parsedQuery.id
      if (parsedQuery.calendly) formFieldPrefills.__calendly = parsedQuery.calendly
      delete formFieldPrefills[currentNavLinkKey] //since prefill not required for slixta navigation link
    } else { // further slixta workflows need to be handled here if any
      formFieldPrefills.__linkType = 'normalLink'
    }
    navLinkformDefinition.formType = 'edit'
  }

  //prefill speical formfields as required
  // console.log('formFieldPrefills', formFieldPrefills)
  // console.log('navLinkformDefinition', navLinkformDefinition)
  Helper.populateFormDefinitionValues(navLinkformDefinition, formFieldPrefills)
  /* ********************************* */

  return (
    <div className={css(Styles.customButtonDataWrapperContainer)}>
      <div className={css(Styles.buttonLabelContainer)} >
        {!props.fieldParams.value ?
          <div
            className={css(Styles.formControlDotted)}
            onClick={() => setShowButtonConfig(!showButtonConfig)}>
            <i class='material-icons-outlined' style={{ fontSize: 30, color: AppConfig.TINT_COLOUR }}>settings</i>
            <span>{isOnlyNavLink() ? Helper.getString('confNavLink') : Helper.getString('configButton')}</span>
          </div>
          :
          <TextField
            error={formControlParams.error}
            required={formControlParams.required}
            variant={'standard'}
            className={css(Styles.formControl)}
            InputProps={{
              disableUnderline: true,
              type: current.subType === 'password' ? 'password' : 'text',
              classes: {
                root: css([Styles.textInputStyles, Styles.textInputStylesDisabled]),
                input: css(Styles.formInputStyle),
              },
            }}
            autoComplete='off'
            {...props.fieldParams}
            value={decodeURIComponent(props.fieldParams.value)}
            disabled={true}
            onClick={() => setShowButtonConfig(!showButtonConfig)}
          />
        }
      </div>
      {navLinkformDefinition.steps[0].fields.length > 0 && (
        <>
          {props.fieldParams.value &&
            <div
              className={props.disabled ? css([Styles.urlBuilderContainer, Styles.textInputStylesDisabled]) : css([Styles.urlBuilderContainer]) }
              onClick={() => {
                if(!props.disabled) setShowButtonConfig(!showButtonConfig)
              }}
            >
              <i class='material-icons-outlined' style={{ fontSize: 30, color: AppConfig.TINT_COLOUR }}>settings</i>
            </div>
          }
          <DynamicFormDialog
            isOpen={showButtonConfig}
            customSubmit={onChangeHandler}
            formDefinition={navLinkformDefinition}
            onClosed={() => setShowButtonConfig(!showButtonConfig)}
          />
        </>
      )}
    </div>
  );
}

const Styles = StyleSheet.create({
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 1024px)': {
      paddingBottom: 80
    },
    '@media (max-width: 320px)': {
      maxWidth: 300,
    }
  },
  textInput: {
    textAlign: 'center'
  },
  leftGridPadding: {
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  rightGridPadding: {
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  errorMsg: {
    paddingRight: 20,
    color: '#f44336'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  marginLeft: {
    color: 'white'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  actionsContainer: {
    '@media (max-width: 1024px)': {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100vw',
      backgroundColor: 'whitesmoke',
      zIndex: 1000,
    }
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30,
    '@media (max-width: 1024px)': {
      alignItems: 'center',
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 5,
      marginRight: 5,
    }
  },
  pendingApprovalLabel: {
    marginTop: 0,
    marginBottom: 0,
    color: 'orange',
    fontSize: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: 'black',
    fontSize: 10,
    cursor: 'pointer',
  },
  uploadFieldLabel: {
    marginTop: 10,
  },
  button: {
    backgroundColor: AppTheme.primaryColor,
    borderRadius: AppTheme.borderRadius,
    display: 'flex',
    alignItems: 'center',
    height: 54,
    minWidth: 150,
    // flex: 1,
    padding: 13,
    fontSize: 16,
    textTransform: 'capitalize',
    color: AppTheme.secondaryBg,
    '@media (max-width: 1024px)': {
      minWidth: 125,
      height: 50
    }
  },
  buttonDisabled: {
    backgroundColor: AppTheme.secondaryColor,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    height: 54,
    minWidth: 150,
    // flex: 1,
    padding: 13,
    fontSize: 16,
    textTransform: 'capitalize',
    color: '#808080',
    boxShadow: 'none',
    border: '1px solid #E5E5E5',
  },
  buttonText: {
    color: AppTheme.secondaryBg,
  },
  buttonDisabledText: {
    color: '#808080',
  },
  buttonDelete: {
    backgroundColor: '#FF0D0D'
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    // marginBottom: 8
    display: 'inline-block'
  },
  labelInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 2,
  },
  filterLabelInnerContainer: {
    minHeight: 45,
    '@media (max-width: 767px)': {
      minHeight: 'unset',
    }
  },
  isEqualSelect: {
    minWidth: 110,
    paddingLeft: 10,
    paddingRight: 5,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 16,
    fontSize: 14,
    color: '#222222',
  },
  isEqualSelection: {
    color: '#222222',
    ':focus': {
      backgroundColor: 'inherit !important',
    }
  },
  isEqualSelectMenu: {
    color: '#222222',
    marginTop: 3,
  },
  formControl: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid ' + AppTheme.borderColor,
    overflow: 'hidden'
  },
  formControlDotted: {
    borderRadius: AppTheme.borderRadius,
    border: '1px dashed ' + AppTheme.borderColor,
    overflow: 'hidden',
    height: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: 10
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: CommonTheme.textColor,
    fontSize: 16
  },
  textInputStylesDisabled: {
    backgroundColor: '#f5f5f5',
  },
  pickerStyle: {
    marginTop: 0
  },
  pickerInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: CommonTheme.textColor,
    fontSize: 16,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid ' + AppTheme.borderColor,
    overflow: 'hidden'
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tag: {
    backgroundColor: AppTheme.secondaryColor,
    color: CommonTheme.textColor,
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  popupIndicator: {
    marginRight: 5,
  },
  dialog: {
    zIndex: 130000,
    fontSize: 16,
    color: CommonTheme.textColor,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
  },

  modalCloseIcon: {
    width: 12,
    height: 12,
    padding: 1,
    //border: '1.5px solid' + CommonTheme.textColor,
    borderRadius: 6
  },

  fieldOuterContainer: {
    display: 'flex'
  },
  fieldLeftInnerContainer: {
    flex: 1,
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  fieldRightInnerContainer: {
    flex: 1,
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  delFieldContainer: {
    width: '25%',
    marginRight: 20
  },
  formControlMain: {
    marginTop: 0,
    marginBottom: 0,
    zIndex: 'auto'
  },
  optionImageContainer: {
    width: 20,
    height: 20,
  },
  optionImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  optionImageContainerSpec: {
    marginRight: 9,
    marginLeft: 5
  },
  // requiredIndicator: {
  //   display: 'flex',
  //   color: CommonTheme.subTextColor,
  //   lineHeight: 0,
  //   alignItems: 'center',
  //   fontSize: 23,
  //   justifyContent: 'flex-end'
  // },
  requiredIndicator: {
    opacity: 0.5,
    height: 7,
    width: 7
  },
  labelContainer: {
    display: 'flex',
    marginBottom: 8
  },
  tooltip: {
    zIndex: 9999999999
  },
  autoCompleteInputRoot: {
    paddingRight: 56
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 50,
    width: '100%',
  },
  optionLoaderSpinner: {
    marginRight: 15
  },
  addOptionStyle: {
    color: AppTheme.buttonBg
  },
  option: {
    '@media (max-width: 1024px)': {
      paddingTop: 0,
      paddingBottom: 0,
      minHeight: 15,
    }
  },
  advancedTitle: {
    color: '#222222',
    fontSize: 20,
    fontWeight: 500,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    width: 50,
  },
  accordionIcon: {
    padding: 0,
  },
  accordionSummary: {
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 20,
    width: 125,
  },
  accordionDetails: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  customButtonDataWrapperContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    width: '100%',
  },
  buttonLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: '100%'
  },
  buttonUrlData: {
    // whiteSpace:'nowrap',
    // overflow:'hidden',
    // textOverflow:'ellipsis'
  },
  urlBuilderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: 'whitesmoke',
    border: '1px solid ' + AppTheme.borderColor,
    padding: 0,
    cursor: 'pointer',
    borderRadius: 16,
    maxWidth: 55,
    width: '100%',
    height: 54,
  },
  urlBuilderText: {
    textAlign: 'center',
    fontSize: 12,
  },
  link: {
    textDecoration: 'none',
    fontSize: 14,
    color: AppTheme.primaryColor,
    margin: 0,
    display: 'inline-block',
    marginLeft: 5,
    marginTop: 0,
    alignSelf: 'center',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textDecorationColor: AppTheme.primaryColor,
      textUnderlineOffset: 2,
    }
  }
});
